import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { CommissionsOutputsContainer } from "./containers/CommissionsOutputsContainer";

export const CommissionsOutputsRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission component={<CommissionsOutputsContainer />} permissions={[Permission.COMMISSIONS]} />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);
